import axiosInstance from 'api/axiosInstance';
import type { DocumentReferenceField } from 'types/repository.types';

const updateDocumentField = (
  documentId: string,
  documentField: Partial<DocumentReferenceField>,
) =>
  axiosInstance.patch<DocumentReferenceField>(
    `/v2/repository-documents/${documentId}/fields/${documentField._id}`,
    documentField,
  );

export default updateDocumentField;
